import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import railStationService from './railStationService'

const initialState = {
    stations: [],
    countries: [],
    stationsForCountry: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

export const autocompleteStations = createAsyncThunk ('stations/autocomplete', async (query, thunkAPI) => {
  try {
      const token = thunkAPI.getState().auth.user.token
      return await railStationService.autocompleteStations(query, token)
  } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      
      // console.log(error)
      return thunkAPI.rejectWithValue(message)
  }
})

export const getCountryList = createAsyncThunk ('stations/getCountryList', async (_, thunkAPI) => {
  try {
      const token = thunkAPI.getState().auth.user.token
      return await railStationService.getCountryList(token)
  } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      
      // console.log(error)
      return thunkAPI.rejectWithValue(message)
  }
})

export const getStationsForCountry = createAsyncThunk ('stations/getStationsForCountry', async (countryCode, thunkAPI) => {
  try {
      const token = thunkAPI.getState().auth.user.token
      return await railStationService.getStationsForCountry(countryCode, token)
  } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      
      // console.log(error)
      return thunkAPI.rejectWithValue(message)
  }
})

export const railStationSlice = createSlice({
    name: 'station',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
              .addCase(autocompleteStations.pending, (state) => {
                state.isLoading = true
              })
              .addCase(autocompleteStations.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.stations = action.payload
              })
              .addCase(autocompleteStations.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
              })

              .addCase(getCountryList.pending, (state) => {
                state.isLoading = true
              })
              .addCase(getCountryList.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.countries = action.payload.output
              })
              .addCase(getCountryList.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
              })

              .addCase(getStationsForCountry.pending, (state) => {
                state.isLoading = true
              })
              .addCase(getStationsForCountry.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.stationsForCountry = action.payload.output
              })
              .addCase(getStationsForCountry.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
              })
    }
})

export const { reset } = railStationSlice.actions
export default railStationSlice.reducer